export enum ListModule {
  CONVERTERS = 'CONVERTERS',
  VEHICLES = 'VEHICLES',
}
